module.exports = __webpack_public_path__ + "img/factor_b_blue.e57812ff.svg";